import { Analytics } from "@vercel/analytics/react";
import {
  createBrowserRouter,
  RouteObject,
  RouterProvider,
} from "react-router-dom";
import { CoordinatesListener } from "./components/coordinatesListener";
import { adminRouter } from "./routes/adminRoutes";
import { router } from "./routes/routes";
import { salesRouter } from "./routes/salesRoutes";
import { websiteRouter } from "./routes/websitePageRoutes";
import { welcomeModalKey } from "./utils/constants";

const getLocalDevRouter = () => {
  const [websiteRoot, ...websiteRest] = websiteRouter;

  const websiteChildren = websiteRoot.children ?? [];
  const isWebsiteSlugRoute = (route: RouteObject) =>
    typeof route.path === "string" && route.path.startsWith(":");
  const routeGroups = [router, adminRouter, salesRouter];

  const websiteSlugChildren = websiteChildren.filter(isWebsiteSlugRoute);
  const websiteStaticChildren = websiteChildren.filter(
    (route) => !isWebsiteSlugRoute(route),
  );

  const localAppChildren = routeGroups.reduce<RouteObject[]>(
    (children, routeGroup) => {
      const rootRoute = routeGroup.find((route) => route.path === "/");

      return children.concat(
        (rootRoute?.children ?? []).filter(
          (route) => !route.index && route.path !== "",
        ),
      );
    },
    [],
  );

  const localFallbackRoutes = routeGroups.reduce<RouteObject[]>(
    (routes, routeGroup) =>
      routes.concat(routeGroup.filter((route) => route.path !== "/")),
    [],
  );

  const localWebsiteRoot: RouteObject = {
    path: websiteRoot.path,
    errorElement: websiteRoot.errorElement,
    children: [
      ...websiteStaticChildren,
      ...localAppChildren,
      ...websiteSlugChildren,
    ],
  };

  return [localWebsiteRoot, ...websiteRest, ...localFallbackRoutes];
};

const getRouter = () => {
  const domain = window.location.hostname;

  let r: RouteObject[] = [];

  if (domain.startsWith("app.") || domain.startsWith("app-")) {
    // Load only client app routes in "app.*" subdomain
    r = router;
  } else if (domain.startsWith("admin.") || domain.startsWith("admin-")) {
    // Load only admin app routes in "admin.*" subdomain
    r = adminRouter;
  } else if (domain.startsWith("sales.") || domain.startsWith("sales-")) {
    // Load only sales app routes in "sales.*" subdomain
    r = salesRouter;
  } else if (
    domain.startsWith("localhost") ||
    domain.startsWith("127.") ||
    domain.startsWith("192.")
  ) {
    // Load all/specific app routes in local development - uncomment as needed
    // r = [...websiteRouter, ...adminRouter, ...router, ...salesRouter];
    r = getLocalDevRouter();
    // r = [...websiteRouter];
    // r = [...adminRouter];
    // r = [...router];
    // r = [...salesRouter];
  } else {
    // Load only website routes as fallback if no conditions are met and sub domain should be used / considered
    r = websiteRouter;
  }

  return createBrowserRouter(r);
};

function App() {
  localStorage.removeItem(welcomeModalKey); // Fix for previous versions of the webapp where this key was set and used...its no longer needed

  return (
    <>
      <RouterProvider router={getRouter()} />
      <CoordinatesListener />
      <Analytics />
    </>
  );
}

export default App;
